'use client'

import { useSyncExternalStore } from 'react'
import NextLink from 'next/link'
import { Theme } from '@astryxdesign/core/theme'
import { LinkProvider } from '@astryxdesign/core/Link'
import { neutralTheme } from '@astryxdesign/theme-neutral/built'

export const THEME_CHANGE_EVENT = 'pm:theme-changed'

export function currentThemeMode() {
  if (typeof document === 'undefined') return 'system'
  const attr = document.documentElement.getAttribute('data-theme')
  if (attr === 'light' || attr === 'dark') return attr
  return 'system'
}

function subscribe(onChange) {
  window.addEventListener(THEME_CHANGE_EVENT, onChange)
  return () => window.removeEventListener(THEME_CHANGE_EVENT, onChange)
}

function getServerSnapshot() {
  return 'system'
}

export default function ThemeProvider({ children }) {
  // External store: documentElement data-theme + pm:theme-changed events.
  // SSR and the first client render both use 'system' (matches the server
  // <Theme> markup), then the browser adopts the persisted mode.
  const mode = useSyncExternalStore(subscribe, currentThemeMode, getServerSnapshot)

  return (
    <LinkProvider component={NextLink}>
      <Theme theme={neutralTheme} mode={mode}>
        {children}
      </Theme>
    </LinkProvider>
  )
}